// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609250100/js/" + chunkId + "." + {"44":"5a102a1f","225":"a4f21de1","481":"84b38982","486":"fb9685fe","770":"cf8248d8"}[chunkId] + ".0.5942198635712932.chunk.js";
};